var _path, _path2, _ellipse, _ellipse2, _path3, _path4, _path5, _ellipse3, _mask, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetriDishLbAmpAra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 29,
    viewBox: "0 -20 101 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.359434 8.92702C0.359435 4.1975 22.8676 0.363458 50.6328 0.36346C78.3981 0.363463 100.906 4.1975 100.906 8.92703C100.906 11.7461 100.906 12.5625 100.906 12.5625C99.1166 5.6956 61.8484 4.16051 50.6328 4.16051C39.4173 4.16051 1.82377 5.21075 0.359434 12.5625C0.359434 12.5625 0.359434 11.7461 0.359434 8.92702Z",
    fill: "#668BA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1.00004 9.43155C1.00004 4.77479 23.1619 0.999735 50.5 0.999738C77.8381 0.99974 100 4.7748 100 9.43156C100 12.2073 100 20.6475 100 20.6475C98.2379 13.8862 61.543 12.3747 50.5 12.3747C39.457 12.3747 2.44185 13.4088 1.00004 20.6475C1.00004 20.6475 1.00004 12.2072 1.00004 9.43155Z",
    fill: "#668BA6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.4999,
    cy: 20.5685,
    rx: 49.4999,
    ry: 8.43182,
    fill: "#CCD8E1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.4999,
    cy: 20.5685,
    rx: 49.4999,
    ry: 8.43182,
    fill: "#FCE19D",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M99.9999 20.5684C99.9999 25.2252 77.838 29.0003 50.5 29.0003C23.1619 29.0003 1.00005 25.2252 1.00005 20.5684C1.00005 17.7927 1 9.35254 1 9.35254C2.76213 16.1138 39.457 17.9434 50.5 17.9434C61.543 17.9434 98.5581 16.5912 99.9999 9.35254C99.9999 9.35254 99.9999 17.7927 99.9999 20.5684Z",
    fill: "#99B2C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5918 18.5C27.5918 18.5 38.9656 19.4545 50.3393 19.4545C61.7131 19.4545 73.0869 18.5 73.0869 18.5V26.7727C73.0869 26.7727 59.15 27.7273 50.3393 27.7273C41.5287 27.7273 27.5918 26.7727 27.5918 26.7727V18.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M100.906 12.4812C100.906 17.2107 78.398 21.0447 50.6328 21.0447C22.8676 21.0447 0.359425 17.2107 0.359425 12.4812C0.359425 9.6621 0.359375 8.8457 0.359375 8.8457C2.14904 15.7126 39.4172 17.5708 50.6328 17.5708C61.8484 17.5708 99.4419 16.1974 100.906 8.8457C100.906 8.8457 100.906 9.6621 100.906 12.4812Z",
    fill: "#99B2C4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 50.6327,
    cy: 8.92684,
    rx: 50.2734,
    ry: 8.56356,
    fill: "#99B2C4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 18
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 50.6328,
    cy: 9.2452,
    rx: 50.2734,
    ry: 8.56356,
    fill: "#99B2C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.1882 21.6862L84.3106 1.16593L75.5249 -0.93457L4.26367 19.9088L14.1882 21.6862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.5293 -0.449219L11.4227 15.87L8.49414 14.9006L62.5095 -0.449219H68.5293Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2812 25.5442H37.8014V24.7939H36.1463V21.6496H35.2812V25.5442Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2661 25.5442H39.9616C40.8786 25.5442 41.2938 25.2063 41.2938 24.4503C41.2938 23.9406 41.1035 23.637 40.6306 23.5053V23.4938C41.0112 23.3621 41.1669 23.0929 41.1669 22.6634C41.1669 21.9646 40.7632 21.6496 39.8405 21.6496H38.2661V25.5442ZM39.1312 23.2017V22.377H39.754C40.175 22.377 40.3134 22.4744 40.3134 22.7836C40.3134 23.0986 40.1635 23.2017 39.7079 23.2017H39.1312ZM39.1312 24.8168V23.9291H39.7425C40.2557 23.9291 40.4287 24.0436 40.4287 24.3816C40.4287 24.708 40.273 24.8168 39.8117 24.8168H39.1312Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4775 26.346H42.2215L44.1534 21.3633H43.4095L41.4775 26.346Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1254 25.6129C45.5233 25.6129 45.8232 25.464 46.0308 25.1719L46.0596 25.5442H46.7805V23.6198C46.7805 22.8409 46.3884 22.4858 45.5349 22.4858C44.7044 22.4858 44.3007 22.8237 44.2546 23.4881H45.0793C45.0908 23.2819 45.2061 23.1502 45.5003 23.1502C45.8059 23.1502 45.927 23.2991 45.927 23.6084V23.7057H45.3734C44.5718 23.7057 44.1738 24.0551 44.1738 24.6851C44.1738 25.2807 44.5314 25.6129 45.1254 25.6129ZM45.3849 24.9486C45.1427 24.9486 45.0158 24.834 45.0158 24.6164C45.0158 24.3987 45.1427 24.267 45.5291 24.267H45.927V24.6106C45.8059 24.834 45.6271 24.9486 45.3849 24.9486Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4783 25.5442H48.3318V23.6256C48.4644 23.3392 48.6317 23.2189 48.8335 23.2189C49.0411 23.2189 49.1622 23.3392 49.1622 23.6026V25.5442H50.0158V23.6256C50.1542 23.3392 50.3156 23.2189 50.5232 23.2189C50.7309 23.2189 50.8462 23.3392 50.8462 23.6026V25.5442H51.6997V23.511C51.6997 22.8409 51.3595 22.4858 50.7482 22.4858C50.3964 22.4858 50.1196 22.6061 49.8889 22.9096C49.7389 22.629 49.4679 22.4858 49.0815 22.4858C48.7124 22.4858 48.4471 22.6176 48.228 22.9211L48.2049 22.5546H47.4783V25.5442Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4174 26.5865H53.2709V25.3036C53.4727 25.5156 53.7265 25.6129 54.0494 25.6129C54.7357 25.6129 55.1221 25.1891 55.1221 24.3816V23.7115C55.1221 22.9039 54.7357 22.4858 54.0494 22.4858C53.6688 22.4858 53.392 22.6176 53.1671 22.9154L53.144 22.5546H52.4174V26.5865ZM53.8534 24.9256C53.5823 24.9256 53.392 24.771 53.2709 24.4675V23.6256C53.392 23.3277 53.5823 23.1731 53.8476 23.1731C54.1244 23.1731 54.2686 23.3335 54.2686 23.7172V24.3816C54.2686 24.771 54.1244 24.9256 53.8534 24.9256Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3937 26.346H56.1377L58.0696 21.3633H57.3257L55.3937 26.346Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0416 25.6129C59.4395 25.6129 59.7394 25.464 59.947 25.1719L59.9759 25.5442H60.6967V23.6198C60.6967 22.8409 60.3046 22.4858 59.4511 22.4858C58.6206 22.4858 58.2169 22.8237 58.1708 23.4881H58.9955C59.007 23.2819 59.1224 23.1502 59.4165 23.1502C59.7221 23.1502 59.8432 23.2991 59.8432 23.6084V23.7057H59.2896C58.488 23.7057 58.0901 24.0551 58.0901 24.6851C58.0901 25.2807 58.4476 25.6129 59.0416 25.6129ZM59.3011 24.9486C59.0589 24.9486 58.9321 24.834 58.9321 24.6164C58.9321 24.3987 59.0589 24.267 59.4453 24.267H59.8432V24.6106C59.7221 24.834 59.5434 24.9486 59.3011 24.9486Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3945 25.5442H62.248V23.8718C62.3288 23.4537 62.5421 23.2876 62.9862 23.2876H63.1477V22.4973H62.9228C62.5075 22.4973 62.2711 22.6863 62.1557 23.1101L62.1211 22.5546H61.3945V25.5442Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3412 25.6129C64.7391 25.6129 65.039 25.464 65.2466 25.1719L65.2754 25.5442H65.9963V23.6198C65.9963 22.8409 65.6041 22.4858 64.7506 22.4858C63.9202 22.4858 63.5165 22.8237 63.4703 23.4881H64.295C64.3066 23.2819 64.4219 23.1502 64.716 23.1502C65.0217 23.1502 65.1428 23.2991 65.1428 23.6084V23.7057H64.5891C63.7875 23.7057 63.3896 24.0551 63.3896 24.6851C63.3896 25.2807 63.7472 25.6129 64.3412 25.6129ZM64.6007 24.9486C64.3585 24.9486 64.2316 24.834 64.2316 24.6164C64.2316 24.3987 64.3585 24.267 64.7449 24.267H65.1428V24.6106C65.0217 24.834 64.8429 24.9486 64.6007 24.9486Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetriDishLbAmpAra);
export default __webpack_public_path__ + "static/media/petri-dish-lb-amp-ara.b4189659770476f918771fcec6918157.svg";
export { ForwardRef as ReactComponent };